import { Icon, IconSize } from '@shipengine/giger';
import { IconNames } from '@shipengine/giger-theme';
import { getTrackingLastCheckpointStyles, getTrackingCheckpointDecorationIconStyles } from './TrackingCheckpointDecorationIconStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';

function TrackingCheckpointDecorationIcon(_ref) {
  let {
    isInitialCheckpoint,
    isLatestCheckpoint,
    ...otherProps
  } = _ref;
  if (isLatestCheckpoint) {
    return jsx(Icon, {
      css: getTrackingLastCheckpointStyles,
      name: IconNames.CHECK,
      size: IconSize.SIZE_SMALL,
      ...otherProps
    });
  } else {
    return jsx("span", {
      css: getTrackingCheckpointDecorationIconStyles(!!isInitialCheckpoint),
      ...otherProps
    });
  }
}

export { TrackingCheckpointDecorationIcon };
//# sourceMappingURL=TrackingCheckpointDecorationIcon.js.map
